import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import { PAY_CARD } from '../../../constants/Routes';
import PayCard from './PayCard';

const PayCardRoutes = ({ ...props }) => {
  const { mobile } = props;
  return (
    <Switch>
      <Route exac path={PAY_CARD}>
        <PayCard mobile={mobile} />
      </Route>
    </Switch>
  );
};

PayCardRoutes.propTypes = {
  mobile: PropTypes.bool,
};

export default PayCardRoutes;
